import { PayloadAction } from '@reduxjs/toolkit';
import axios, { AxiosResponse, isAxiosError } from 'axios';
import { put, takeEvery } from 'redux-saga/effects';
// import L from 'i18n-react';
import { responseErrors } from 'services';
import { downloadFile } from 'untils/downloadFile';
import { onHttp } from 'untils/onHttp';
import { downloadInitState, getFileRequest, getFileSuccess } from './reducer';
import { IFileConfig } from './types';

function* getFileWorker(action: PayloadAction<IFileConfig>) {
  const { endpoint } = action.payload;

  try {
    const response: AxiosResponse<Blob> = yield axios({
      method: 'get',
      url: onHttp() + endpoint,
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
      },
    });

    const contentType = String(response.headers['content-type'] ?? 'application/octet-stream');

    const contentDisposition = String(response.headers['content-disposition'] ?? '');

    downloadFile(response.data, contentType, contentDisposition);

    yield put(getFileSuccess());
  } catch (error) {
    console.log(error);
    yield put(downloadInitState());

    if (isAxiosError(error)) responseErrors(error.response);
  }
}

export function* downloadSaga() {
  yield takeEvery(getFileRequest.type, getFileWorker);
}
